import { useMutation } from '@tanstack/react-query'
import { sendHelpBotMessage } from './helpBotApi'

const ERROR_MESSAGES = {
    server: 'Something went wrong. Please try again.',
    network: 'Sorry, unable to get a response. Please try again later.',
}

const getErrorMessage = (error) => {
    if (error.status >= 400) return ERROR_MESSAGES.server
    return ERROR_MESSAGES.network
}

export const useHelpBot = () => {
    const { mutate: sendMessage, isPending } = useMutation({
        mutationFn: sendHelpBotMessage,
        onSuccess: (response, variables) => {
            variables?.onSuccess?.(response)
        },
        onError: (error, variables) => {
            const errorMessage = getErrorMessage(error)
            variables?.onError?.(errorMessage)
        },
    })

    return {
        sendMessage,
        isPending,
    }
}
